import { enumManagers } from '@chirp/enums';
import React from 'react';

import {
  EmergencyScenarioAccessPointTableFragment as EmergencyScenarioAccessPoint,
} from '../../graphql/api/generated';
import * as emergencyScenarioColumns from '../EmergencyScenario/columns';
import { EmergencyScenarioModel } from '../EmergencyScenario/model';

import { EmergencyPlanWithIcon } from './components/EmergencyPlanWithIcon';
import model from './model';

export const emergencyScenarioNameColumn = model.createColumn<EmergencyScenarioAccessPoint>({
  title: 'Name',
  render: ({ emergencyScenario }) => (
    EmergencyScenarioModel.routes.renderRowLink(emergencyScenario)
  ),
});

export const emergencyScenarioStatusColumn = model.createColumn<EmergencyScenarioAccessPoint>({
  title: 'Status',
  render: ({ emergencyScenario }) => (
    emergencyScenarioColumns.statusColumn.render(emergencyScenario)
  ),
  renderString: ({ emergencyScenario }) => (
    enumManagers.EmergencyScenarioStatus.getLabel(emergencyScenario.status) || ''
  ),
});

export const emergencyPlanColumn = model.createColumn<EmergencyScenarioAccessPoint>({
  title: 'Emergency Plan',
  render: ({ emergencyPlan }) => {
    return <EmergencyPlanWithIcon emergencyPlan={emergencyPlan} />;
  },
  renderString: ({ emergencyPlan }) => (
    enumManagers.EmergencyPlan.getLabel(emergencyPlan) || ''
  ),
});
